import { cached, Refused } from '@porotutu/react'
import { permit } from '@porotutu/react/permit'
import type { QueryKey } from '@tanstack/react-query'
import { profileQuery } from '@/session/profile'
import type { RouterContext } from './root'

export const actsRoute =
  <R extends { acts: string[] }>(slice: string, act: R['acts'][number]) =>
  <P>(record: (params: P) => { queryKey: QueryKey }) =>
  async ({ context, params }: { context: RouterContext; params: P }) => {
    const held: R = await context.queryClient.query(cached(record(params)))

    if (!held.acts.includes(act)) throw new Refused(slice)
  }

export const grantedRoute =
  <P>(slice: string, grant: (params: P) => string) =>
  async ({ context, params }: { context: RouterContext; params: P }) => {
    const profile = await context.queryClient.query(cached(profileQuery))

    if (profile === null || !permit(profile.permissions).can(grant(params))) {
      throw new Refused(slice)
    }
  }
